module.exports = __webpack_public_path__ + "static/media/WebText_1000.b2c026b9.png";